import colorVars from "@/assets/styles/colorVars"
import { BlueButton, IButton } from "@/components/button"
import Heading from "@/components/heading"
import { Spacer } from "@/components/spacer"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

export interface IFinalCta {
  button?: IButton
  description?: string
  title?: string
}

export interface FinalCtaProps {
  className?: string
  data: IFinalCta
}

export const CtaSection = styled.section`
  position: relative;
  padding: 0 16px;
  overflow: hidden;
`

export const BasicSectionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Description = styled.p`
  max-width: 490px;
  margin: -5px auto 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  color: ${colorVars.text.gray};

  text-align: center;
  mix-blend-mode: luminosity;

  ${up("md")} {
    max-width: 620px;
    margin: 0 auto;
    font-size: 20px;
    line-height: 35.711px;
  }
`

export const FinalCta: FC<FinalCtaProps> = (props) => {
  const { className, data } = props

  return (
    <CtaSection className={className !== "" ? className : ""}>
      <BasicSectionWrapper>
        <Heading center size="cta" title={data?.title} whiteGradient />
        <Spacer height={{ default: "16px" }} />
        <Description>{data?.description}</Description>
        <Spacer height={{ default: "38px", md: "40px" }} />
        <BlueButton center link={data?.button} type="url" />
      </BasicSectionWrapper>
      <Spacer height={{ default: "34px", md: "78px" }} />
    </CtaSection>
  )
}
